import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axiosInstance from "@/api/axios";

const LogoutPage = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const handleLogout = async () => {
            try {
                await axiosInstance.post("/user/logout", null, {
                    withCredentials: true,
                });
                console.log("Logout successful on server.");
            } catch (e) {
                // It's okay if this fails (e.g. session already expired)
                console.error("Logout API call failed (might be okay):", e.response || e);
            } finally {
                // Clear auth state — but intentionally keep plaex_user_* bin/filter
                // selections so they persist when the same user logs back in
                localStorage.removeItem("loggedin");
                localStorage.removeItem("userRole");

                // We keep "userId" in localStorage ON PURPOSE:
                // It's used as the key prefix for bin selections (plaex_user_${userId}_*)
                // Removing it would orphan the saved selections and they'd never load again.
                // The next login will overwrite it with the correct user's ID anyway.

                navigate("/login", { replace: true });
            }
        };

        handleLogout();
    }, []);

    return <div></div>;
};

export default LogoutPage;